module.exports = __webpack_public_path__ + "static/img/hmInspection.e1338a7e.png";